export function LoadingView({ label = "Loading..." }) {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: 220 }}>
      <div className="row">
        <div
          style={{
            width: 22,
            height: 22,
            border: "3px solid var(--color-border)",
            borderTopColor: "var(--color-electric)",
            borderRadius: "50%",
            animation: "spin 800ms linear infinite",
          }}
        />
        <span>{label}</span>
      </div>
      <style>{`@keyframes spin { from { transform: rotate(0deg);} to { transform: rotate(360deg);} }`}</style>
    </div>
  );
}

export function TableSkeleton() {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Loading</th>
            <th>Loading</th>
            <th>Loading</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, idx) => (
            <tr key={idx}>
              <td>
                <div className="skeleton" />
              </td>
              <td>
                <div className="skeleton" />
              </td>
              <td>
                <div className="skeleton" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
